import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ImageState {
  id?: string;
  name: string;
  size: number;
  progress: number;
  isError?: boolean;
  file?: File;
}

export interface ProjectState {
  uploadedImages: ImageState[];
  failedImages: ImageState[];
}

const initialState: ProjectState = {
  uploadedImages: [],
  failedImages: [],
};

export const projectSlice = createSlice({
  name: 'project',
  initialState,
  reducers: {
    setUploadedImages: (state, action: PayloadAction<ImageState[]>) => {
      state.uploadedImages = action.payload;
    },
    updateImageState: (state, action: PayloadAction<{ name: string; progress: number; id?: string }>) => {
      state.uploadedImages = state.uploadedImages.map((image) => {
        if (image.name === action.payload.name) {
          return { ...image, id: action.payload.id, progress: action.payload.progress };
        }
        return image;
      });
    },
    deleteImageState: (state, action: PayloadAction<string>) => {
      state.uploadedImages = state.uploadedImages.filter((image) => image.name !== action.payload);
    },
    deleteFailedImage: (state, action: PayloadAction<string>) => {
      state.failedImages = state.failedImages.filter((image) => image.name !== action.payload);
    },
    setFailedImages: (state, action: PayloadAction<ImageState[]>) => {
      state.failedImages = action.payload;
    },
    addFailedImages: (state, action: PayloadAction<ImageState>) => {
      state.failedImages.push(action.payload);
    },
  },
});

export const { setUploadedImages, setFailedImages, updateImageState, deleteImageState, deleteFailedImage, addFailedImages } =
  projectSlice.actions;

export default projectSlice.reducer;
